import React from 'react';

const NotFound = () => {
  return (
    <div className='w-full h-screen flex flex-col justify-center items-center'>
        <p className='font-bebas text-8xl'>404</p>
        <p className='font-bebas text-3xl'>not found</p>
    </div>
  );
};

export default NotFound;